import { ItemSourceMeanValidatorItemStatus } from 'constants/itemSourceMeanValidatorStatus';

export function itemSourceMeanValidatorItemStatusRenderer(params: { value?: any }) {
  if (params.value === undefined || params.value === null) {
    return '';
  }

  const status = parseInt(params.value);

  switch (status) {
    case ItemSourceMeanValidatorItemStatus.PENDING:
      return '<span class="fa fa-circle-pause" style="color: #ff9800;" title="Pending"></span>';
    case ItemSourceMeanValidatorItemStatus.NEEDS_USER_REVIEW:
      return '<span class="fa fa-user" style="color: #2196f3;" title="Needs User Review"></span>';
    case ItemSourceMeanValidatorItemStatus.DONE:
      return '<span class="fa fa-check-circle" style="color: #4caf50;" title="Done"></span>';
    default:
      return '';
  }
}